import localeAntd from 'antd/es/locale/default';

const topBar = {
  'topBar.profileMenu.hello': 'Përshëndetje',
  'topBar.profileMenu.billingPlan': 'Plani i pagesës',
  'topBar.profileMenu.role': 'Roli',
  'topBar.profileMenu.email': 'Adresa',
  'topBar.profileMenu.phone': 'Tel.',
  'topBar.profileMenu.editProfile': 'Ndrysho Profilin',
  'topBar.profileMenu.logout': 'Dil',
};

const login = {
  'login.form.title': 'Kyçu në llogarinë tuaj',
  'login.form.submitBtn': 'Kyçu',
  'login.form.email': 'Adresa elektronike',
  'login.form.password': 'Fjalëkalimi',
  'login.title': 'Kyçu',
  'login.form.validation.email.required': 'Ju lutem shtypni adresën elektronike',
  'login.form.validation.password.required': 'Ju lutem shtypni fjalëkalimin',
};

const mainMenu = {
  'main.menu.left.home': 'Kryefaqja',
  'main.menu.left.campaign': 'Kampanjat',
  'main.menu.left.members': 'Përdoruesit',
  'main.menu.left.winners': 'Fituesit',
};

const campaigns = {
  'campaigns.title': 'Kampanjat',
  'campaigns.header.new': 'Shto kampanjë',
  'campaigns.table.header.title': 'Titulli',
  'campaigns.table.header.description': 'Përshkrimi',
  'campaigns.table.header.gifts': 'Dhuratat',
  'campaigns.table.header.validFrom': 'Valide prej',
  'campaigns.table.header.validTo': 'Valide deri në',
  'campaigns.table.header.published': 'Publikuar',
  'campaigns.table.header.active': 'Aktive',
  'campaigns.table.emptyText': 'Ska kampanja',
  'campaigns.table.popover.unpublish':
    'A jeni i sigurtë që doni ta largoni nga publikimi këtë kampanjë?',
  'campaigns.table.popover.publish': 'A jeni i sigurtë që doni ta publikoni këtë kampanjë?',
  'campaigns.table.popover.okText': 'Po',
  'campaigns.table.popover.cancelText': 'Jo',
  'campaigns.notification.fetch.error':
    'Ka ndodhur një problem në ngarkimin e kampanjës, ju lutem provoni përsëri',
};

const campaign = {
  'campaign.details.title': 'Detajet e kampanjës',
  'campaign.reports.title': 'Raportet e kampanjës',
  'campaign.new.title': 'Shto kampanjë',
  'campaign.button.save': 'Ruaj',
  'campaign.button.create': 'Shto',
  'campaign.form.validation.title.required': 'Ju lutem shtypni emrin',
  'campaign.form.validation.description.required': 'Ju lutem shtypni përshkrimin',
  'campaign.form.validation.validFrom.required': 'Ju lutem shtypni datën',
  'campaign.form.validation.validTo.required': 'Ju lutem shtypni datën',
  'campaign.form.item.title.label': 'Emri i kampanjës',
  'campaign.form.item.image.label': 'Posteri i kampanjës',
  'campaign.form.item.validFrom.label': 'Data e fillimit',
  'campaign.form.item.validTo.label': 'Data e mbarimit',
  'campaign.form.item.description.label': 'Përshkrimi i kampanjës',
  'campaign.table.header.title': 'Titulli',
  'campaign.table.header.magicNumber': 'Numri magjik',
  'campaign.table.header.remaining': 'Mbetur',
  'campaign.table.header.initial': 'Totali',
  'campaign.table.header.active': 'Aktive',
  'campaign.table.title': 'Dhuratat e kampanjës',
  'campaign.table.emptyText': 'Ska dhurata',
  'campaign.table.popover.title': 'A jeni i sigurtë që doni ta fshini këtë dhuratë?',
  'campaign.table.popover.okText': 'Po',
  'campaign.table.popover.cancelText': 'Jo',
  'campaign.gift.form.item.name.label': 'Emri',
  'campaign.gift.form.item.image.label': 'Fotoja',
  'campaign.gift.form.item.description.label': 'Përshkrimi',
  'campaign.gift.form.item.magicNumber.label': 'Numri magjik',
  'campaign.gift.form.item.totalGifts.label': 'Totali i dhuratave',
  'campaign.gift.form.item.name.placeholder': 'Shtypni emrin',
  'campaign.gift.form.item.description.placeholder': 'Shtypni përshkrimin',
  'campaign.gift.form.item.magicNumber.placeholder': 'Shtypni numrin magjik',
  'campaign.gift.form.item.totalGifts.placeholder': 'Shtypni numrin e dhuratave',
  'campaign.gift.form.validation.title.required': 'Ju lutem shtypni emrin',
  'campaign.gift.form.validation.magicNumber.required': 'Ju lutem shtypni numrin magjik',
  'campaign.gift.form.validation.magicNumber.onlyNumbers':
    'Numri magjik duhet të përmbajë vetëm numra',
  'campaign.gift.form.validation.totalGifts.required': 'Ju lutem shtypni totalin',
  'campaign.gift.form.validation.totalGifts.onlyNumbers': 'Totali duhet të përmbajë vetëm numra',
  'campaign.gift.button.save': 'Ruaj',
  'campaign.gift.button.cancel': 'Anulo',
  'campaign.gift.details.title': 'Detajet e dhuratës',
  'campaign.gift.new.title': 'Dhuratë e re',
  'campaign.qrcode.form.item.amount.placeholder': 'Shuma e numrave',
  'campaign.qrcode.form.item.pin.placeholder': 'Pin',
  'campaign.qrcode.form.validation.amount.required': 'Ju lutem shtypni shumën',
  'campaign.qrcode.form.validation.pin.required': 'Ju lutem shtypni pin-in',
  'campaign.qrcode.form.validation.amount.max': 'Shuma duhet të jetë më pak se 1 milion',
  'campaign.qrcode.form.validation.amount.onlyNumbers': 'Shuma duhet të përmbajë vetëm numra',
  'campaign.qrcode.form.validation.pin.valid': 'Pin-i duhet të jetë valid',
  'campaign.qrcode.button.generate': 'Gjenero',
  'campaign.qrcode.button.cancel': 'Anulo',
  'campaign.qrcode.title': 'Gjenerimi i QR Kodeve për kampanjë',
  'campaign.loosers.button.generate': 'Gjenero Humbësit',
  'campaign.notification.success.title': 'Sukses',
  'campaign.notification.error.title': 'Gabim',
  'campaign.notification.edit.success': 'Kampanja është ndryshuar me sukses',
  'campaign.notification.edit.error':
    'Ka ndodhur një problem gjatë ndryshimit të kampanjës, ju lutem provoni përsëri',
  'campaign.notification.save.success': 'Kampanja është shtuar me sukses',
  'campaign.notification.save.error':
    'Ka ndodhur një problem gjatë shtimit të kampanjës, ju lutem provoni përsëri',
  'campaign.notification.fetch.error':
    'Ka ndodhur një problem gjatë ngarkimit të kampanjës, ju lutem provoni përsëri',
  'campaign.notification.load.error':
    'Ka ndodhur një problem gjatë ngarkimit të kampanjës, ju lutem provoni përsëri',
  'campaign.notification.load.gift.error':
    'Ka ndodhur një problem gjatë ngarkimit të dhuratës, ju lutem provoni përsëri',
  'campaign.notification.save.gift.error':
    'Ka ndodhur një problem gjatë ruajtjes të dhuratës, ju lutem provoni përsëri',
  'campaign.notification.load.gifts.error':
    'Ka ndodhur një problem gjatë ngarkimit të dhuratave, ju lutem provoni përsëri',
  'campaign.notification.publish.error':
    'Ka ndodhur një problem gjatë publikit të kampanjës, ju lutem provoni përsëri',
  'campaign.notification.unpublish.error': `Ka ndodhur një problem gjatë ç'publikimit, ju lutem provoni përsëri`,
  'campaign.notification.generation.success': 'Gjenerimi u krye me sukses',
  'campaign.notification.generation.error':
    'Ka ndodhur një problem gjatë, ju lutem provoni përsëri',
  'campaign.notification.delete.error':
    'Ka ndodhur një problem gjatë fshirjes të dhuratës, ju lutem provoni përsëri',
  'campaign.notification.magicNumber.error':
    'Numri magjik veçse ekziston, ju lutem shtypni një tjetër',
  'campaign.notification.dateFromGreaterThanDateTo.error':
    'Data prej nuk mund të jetë më e madhe se ajo e fundit',
  'campaign.notification.gift.operators.error':
    'Ka ndodhur një problem gjatë ngarkimit të operatorëve, ju lutem provoni përsëri',
};

const reports = {
  'reports.title': 'Reportet',
  'reports.campaign.gifts.table.title': 'Dhuratat e kampanjës',
  'reports.campaign.gifts.table.emptyText': 'Ska dhurata',
  'reports.campaign.gifts.table.columns.title': 'Titulli',
  'reports.campaign.gifts.table.columns.remaining': 'Mbetur',
  'reports.campaign.gifts.table.columns.totalWon': 'Te fituara',
  'reports.campaign.gifts.table.winner.title': 'Fituesit',
  'reports.campaign.gifts.table.winner.table.name': 'Emri',
  'reports.campaign.gifts.table.winner.table.phoneNumber': 'Nr. i tel',
  'reports.campaign.coupons.filterForm.from.placeholder': 'Prej',
  'reports.campaign.coupons.filterForm.to.placeholder': 'Deri në',
  'reports.campaign.coupons.filterForm.button': 'Eksporto kuponët',
  'reports.campaign.coupons.filterForm.validation.from.required': 'Ju lutem shtypni prej',
  'reports.campaign.coupons.filterForm.validation.to.required': 'Ju lutem shtypni deri në',
  'reports.campaign.coupons.filterForm.validation.fromIsGreater':
    'Data prej nuk mund të jetë më e madhe se ajo e fundit',
  'reports.campaign.gifts.notification.fetch.error':
    'Ka ndodhur një problem gjatë ngarkimit të dhuratave, ju lutem provoni përsëri',
  'reports.campaign.gifts.winners.notification.fetch.error':
    'Ka ndodhur një problem gjatë ngarkimit të fituesve, ju lutem provoni përsëri',
  'reports.campaign.coupons.notification.export.error':
    'Ka ndodhur një problem gjatë eksportimit të kuponëve, ju lutem provoni përsëri',
};

const members = {
  'members.title': 'Përdoruesit',
  'members.table.headers.name': 'Emri',
  'members.table.headers.phoneNumber': 'Numri i tel.',
  'members.table.headers.birthday': 'Ditëlindja',
  'members.table.headers.gender': 'Gjinia',
  'members.table.headers.city': 'Qyteti',
  'members.notification.error.title': 'Gabim',
  'members.notification.fetch.error':
    'Ka ndodhur një problem gjatë ngarkimit të përdoruesve, ju lutem provoni përsëri',
  'members.table.headers.totalScanned': 'Të skanuara',
  'members.input.search.placeholder': 'Kërko përdorues...',
  'members.table.emptyText': 'Ska përdorues',
  'members.notification.pagination.noData.title': 'Ska të dhëna',
  'members.notification.pagination.noData.description': 'Nuk ka më të dhëna në faqen tjetër',
  'members.notification.pagination.error':
    'Ka ndodhur një problem gjatë ngarkimit të përdoruesve për faqen e kërkuar, ju lutem provoni përsëri',
  'members.filter.notification.dateFromGreaterThanDateTo.error':
    'Data prej nuk mund të jetë më e madhe se ajo e fundit',
  'members.filter.notification.noData.desription':
    'Nuk ka përdorues pas filtrimit, ju lutem provoni pas një kohe',
  'members.filter.notification.filter.description':
    'Ka ndodhur një problem gjatë filtrimit, ju lutem provoni përsëri',
  'members.filter.notification.error.title': 'Gabim',
  'members.filter.title': 'Filtro',
  'members.filter.form.item.dateFrom.label': 'Prej',
  'members.filter.form.item.dateFrom.placeholder': 'Zgjedh datën',
  'members.filter.form.item.dateTo.label': 'Në',
  'members.filter.form.item.dateTo.placeholder': 'Zgjedh datën',
  'members.filter.button.cancel': 'Anulo',
  'members.filter.button.filter': 'Filtro',
  'members.filter.form.validation.dateFrom.required': 'Ju lutem shtypni datën',
  'members.filter.form.validation.dateTo.required': 'Ju lutem shtypni datën',
};

const winners = {
  'winners.title': 'Fituesit',
  'winners.table.headers.name': 'Emri',
  'winners.table.headers.phoneNumber': 'Numri i tel.',
  'winners.table.headers.birthday': 'Ditëlindja',
  'winners.table.headers.gender': 'Gjinia',
  'winners.table.headers.city': 'Qyteti',
  'winners.table.headers.totalScanned': 'Të skanuara',
  'winners.table.headers.totalGifts': 'Total dhurata',
  'winners.table.headers.status': 'Statusi',
  'winners.table.headers.claimedGifts': 'Marrur',
  'winners.table.headers.lastGiftWon': 'Dhurata e fundit e fituar',
  'winners.input.search.placeholder': 'Kërko fitues...',
  'winners.input.searchCoupon.placeholder': 'Kërko kupona...',
  'winners.gifts.table.headers.title': 'Titulli',
  'winners.gifts.table.headers.dateWon': 'Fituar më',
  'winners.gifts.table.headers.claimed': 'Marrur',
  'winners.gifts.table.emptyText': 'Ska dhurata',
  'winners.gifts.table.popover.unclaim': 'A jeni i sigurtë që dhurata nuk është dërguar?',
  'winners.gifts.table.popover.claim': 'A jeni i sigurtë që dhurata është dërguar?',
  'winners.gifts.table.popover.okText': 'Po',
  'winners.gifts.table.popover.cancelText': 'Jo',
  'winners.gifts.title': 'Dhuratat e fituesit',
  'winners.table.emptyText': 'Ska fitues',
  'winners.searchCoupon.title': 'Kërko Kupon',
  'winners.searchCoupon.descriptions.winningGiftId': 'ID-ja fituese e dhuratës:',
  'winners.searchCoupon.descriptions.userId': 'ID-ja e përdoruesit:',
  'winners.searchCoupon.descriptions.campaignId': 'ID-ja e kampanjës:',
  'winners.searchCoupon.descriptions.createdAt': 'Krijuar me:',
  'winners.searchCoupon.descriptions.dateUsed': 'Data e përdorimit:',
  'winners.searchCoupon.descriptions.used': 'Përdorur:',
  'winners.searchCoupon.descriptions.updatedAt': 'Përditësuar me:',
  'winners.searchCoupon.buttons.update': 'Përditëso kodin si të pa-përdorur',
  'winners.notification.error.title': 'Gabim',
  'winners.notification.fetch.error':
    'Ka ndodhur një problem gjatë ngarkimit të fituesve, ju lutem provoni përsëri',
  'winners.notification.refetch.error':
    'Ka ndodhur një problem gjatë ri-ngarkimit të fituesve, ju lutem provoni përsëri',
  'winners.notification.gifts.fetch.error':
    'Ka ndodhur një problem gjatë ngarkimit të dhuratave të fituesit, ju lutem provoni përsëri',
  'winners.notification.gifts.claim.error':
    'Ka ndodhur një problem gjatë marrjes së dhuratës, ju lutem provoni përsëri',
  'winners.notification.pagination.noData.title': 'Ska të dhëna',
  'winners.notification.pagination.noData.description': 'Ska të dhëna në faqen tjetër',
  'winners.notification.pagination.error':
    'Ka ndodhur një gabim gjatë ngarkimit të fituesve për faqen e kërkuar, ju lutem provoni përsëri',
  'winners.notification.searchCoupon.error':
    'Ka ndodhur një gabim gjatë ngarkimit të kuponit, ju lutem provoni përsëri',
  'winners.notification.updateCoupon.error':
    'Ka ndodhur një gabim gjatë përditësimit të kuponit, ju lutem provoni përsëri',
  'winners.notification.searchCoupon.noData.title': 'Nuk u gjet',
  'winners.notification.searchCoupon.noData.description': 'Kuponi nuk u gjet',
};

const user = {
  'user.dataDeletion.title': 'Fshirja e të dhënave',
  'user.dataDeletion.form.title': 'Fshirja e të dhënave të Facebook-ut',
  'user.dataDeletion.form.button.confirm': 'Konfirmo',
  'user.dataDeletion.form.button.delete': 'Fshij',
  'user.dataDeletion.form.item.email.placeholder': 'Adresa elektronike',
  'user.dataDeletion.form.item.email.confirmationCode': 'Kodi i konfirmimit',
  'user.dataDeletion.form.important.title': 'E rëndësishme:',
  'user.dataDeletion.form.important.description':
    'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut earum maiores praesentium magni velit',
  'user.dataDeletion.form.validation.email.required': 'Ju lutem shtypni adresën elektronike',
  'user.dataDeletion.form.validation.email.valid': 'Adresa elektronike jo-valide',
  'user.dataDeletion.form.validation.confirmationCode.required':
    'Ju lutem shtypni kodin e konfirmimit',
  'user.table.popover.grantAdminRole.title': 'Aksesi i Adminit',
  'user.table.popover.grantAdminRole.description.email.label': 'Adresa',
  'user.table.popover.grantAdminRole.description.email.noData': 'Nuk ka adresë elektronike',
  'user.table.popover.grantAdminRole.button.giveAccess': 'Jepi akses admini',
  'user.table.popover.grantAdminRole.button.revokeAccess': 'Hiqja aksesin adminit',
  'user.table.popover.grantAdminRole.button.cancel': 'Anulo',
  'user.notification.authorization.error.title': 'Autorizimi',
  'user.notification.authorization.error.description':
    'Akses jo i autorizuar, ju lutem kontaktoni përsonelin kompetent',
  'user.notification.error.title': 'Gabim',
  'user.notification.success.title': 'Sukses',
  'user.notification.grantAdminRole.success':
    'Aksesi i përdoruesit u përditesua në Admin me sukses',
  'user.notification.grantAdminRole.error':
    'Ka ndodhur një gabim gjatë ndryshimit të aksesit për admin, ju lutem provoni përsëri',
  'user.notification.removeAdminRole.success': 'Aksesi i përdoruesit u përditesua me sukses',
  'user.notification.removeAdminRole.error':
    'Ka ndodhur një gabim gjatë ndryshimit të aksesit të përdoruesit, ju lutem provoni përsëri',
};

const about = {
  'about.content.title': 'Rreth nesh',
  'about.content.description': `Aplikacioni PATOS është aplikacioni parë vendor i ndërtuar për Atlantik Group sh.p.k.\nPATOS mundëson konsumatorëve të tij që të bëhen pjesë e lojrave shpërblyese në kampanja të ndryshme. Përdorimi i aplikacionit është shumë i thjeshtë.\nPas regjistrimit hap paketimin e çipsit, skano QR kodin që gjendet në të dhe fillo lojën!`,
};

const messages = {
  ...topBar,
  ...login,
  ...mainMenu,
  ...campaigns,
  ...campaign,
  ...members,
  ...winners,
  ...user,
  ...about,
  ...reports,
};

export default {
  locale: 'al-AL',
  localeAntd,
  messages,
};
